var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPromocode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "M.7275 4.6667C.7275 3.7474 1.4523 3 2.3437 3h11.3131c.8914 0 1.6162.7474 1.6162 1.6667v1.6666c0 .2292-.1869.4089-.3965.4844-.4747.1693-.8156.6354-.8156 1.1823s.3409 1.013.8156 1.1823c.2096.0755.3965.2552.3965.4844v1.6666c0 .9193-.7248 1.6667-1.6162 1.6667H2.3437c-.8914 0-1.6162-.7474-1.6162-1.6667V9.6667c0-.2292.187-.4089.3965-.4844.4747-.1693.8157-.6354.8157-1.1823s-.341-1.013-.8157-1.1823c-.2096-.0755-.3965-.2552-.3965-.4844z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPromocode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/promocode.d9a4d1cd8bf37c649695dcf3764e33c4.svg";